import React from 'react';

class DocusignCompleted extends React.Component<{},{}> {

    

    public render() {
        
         return (<div>
            <p> Process completed</p>
         </div>);
    }
}
export default DocusignCompleted;
